module.exports = "<ui-view></ui-view>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/editor/editorLayout.jade
// module id = 311
// module chunks = 0